import { render, staticRenderFns } from "./StandardChecklists.vue?vue&type=template&id=579fd334"
import script from "./StandardChecklists.vue?vue&type=script&lang=js"
export * from "./StandardChecklists.vue?vue&type=script&lang=js"
import style0 from "./StandardChecklists.vue?vue&type=style&index=0&id=579fd334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports